import React from 'react';
import clsx from 'clsx';
import type { ReleaseThemeId } from 'fym-shared/src/music24/releaseThemes';
import type { LyricSampleStyle } from 'fym-shared/src/music24/releaseKitLookSamples';
import { TypedMemo } from '../../../common/types';
import { lyricSampleUrl } from './themeStillVars';
import styles from './LyricCardSample.module.scss';

interface LyricCardSampleProps {
  themeId: ReleaseThemeId;
  style: LyricSampleStyle;
  className?: string;
}

/**
 * The preview of a lyric card in a theme and a style: the square still that the real renderer
 * made of a chorus line of "Forests" by LaziiBee (owner decision 2026-10-05). The song of the user
 * has no lyric line to show yet, so the preview is the sample, not the user's song.
 */
const LyricCardSampleComponent: React.FC<LyricCardSampleProps> = ({ themeId, style, className }) => (
  <img
    className={clsx(styles.lyric, className)}
    src={lyricSampleUrl(themeId, style)}
    alt=""
    aria-hidden="true"
    loading="lazy"
    data-testid={`lyric-sample-${themeId}-${style}`}
  />
);

export const LyricCardSample = TypedMemo(LyricCardSampleComponent);
